import { useState } from 'react'

import { customPost } from '../utils/customFetch.ts'

import { makeUrlReservationArchive } from './connectionData.tsx'

const useReservationArchive = () => {
  const [errorReservationArchive, setErrorReservationArchive] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const reservationArchive = async (_id: string, by: string) => {
    setLoading(true)

    try {
      const apiUrl = makeUrlReservationArchive()
      const res = await customPost<{ message: string }>(apiUrl, { _id, by })
      setErrorReservationArchive(null)

      return res
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorReservationArchive(err)
      } else {
        setErrorReservationArchive(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorReservationArchive, loading, reservationArchive }
}
export default useReservationArchive
